import { render } from "./ViewsPrivacy.vue?vue&type=template&id=3922bc78"
import script from "./ViewsPrivacy.vue?vue&type=script&lang=js"
export * from "./ViewsPrivacy.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__